export * from "./registration.component";
export * from "./registration.module";



// WEBPACK FOOTER //
// ./src/app/public/registration/index.ts